@if(service.viewDroplistItems.length){
<div class='finance-cost-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	<ng-container [ngSwitch]="selectedViewItem.uniqueId">
		<finance-cost-trimester-view-part
			*ngSwitchCase="service.viewId.Trimester"></finance-cost-trimester-view-part>
	</ng-container>
	}

</div>
}